<template>
  <div style="width: 100%;padding: 40px;">
    <div v-if="isLoading" class="loading-overlay">
      <div class="loading-spinner"></div>
      <div class="loading-text">Carregando...</div>
    </div>
    <header id="wrapper-header" role="main" v-show="!isDashboardMode">
      <div style="padding-left: 15px;padding-right: 15px;padding-bottom: 5px;">
        <div class="row">
          <div class="wrapper-header-block col-12">
            <!-- <h2 class="title">Consumo</h2> -->
            <div id="pnlGrid_ren" v-show="showGrid">
              <b-collapse id="collapse1" style="display:block!important;">
                <b-row>
                  <b-col>

                    <b-card no-body id="resumo" class="mb-1 block-resumo">
                      <b-card-header header-tag="header" class="p-2" role="tab">Resumo</b-card-header>
                      <b-card-body>

                        <b-list-group>
                          <b-list-group-item class="item-group-nav d-flex justify-content-between align-items-center">
                            <strong>Conta</strong>
                            <b-badge variant="light" pill>{{ leadAccount }}</b-badge>
                          </b-list-group-item>
                          <b-list-group-item class="item-group-nav d-flex justify-content-between align-items-center">
                            <strong>Empresa</strong>
                            <b-badge variant="light" pill>{{ leadClient }}</b-badge>
                          </b-list-group-item>
                          <b-list-group-item class="item-group-nav d-flex justify-content-between align-items-center">
                            <strong>Consumido pela Empresa</strong>
                            <b-badge variant="info" pill>
                              {{ ((saldoTotal) -
                                leadMyAccumulated < 0 ? 0 : ((saldoTotal) - leadMyAccumulated)).toLocaleString("PT-br") }}
                                </b-badge>
                          </b-list-group-item>
                          <b-list-group-item class="item-group-nav d-flex justify-content-between align-items-center">
                            <strong>Consumido por mim</strong>
                            <b-badge variant="info" pill>{{ leadMyAccumulated.toLocaleString("PT-br") }}</b-badge>
                          </b-list-group-item>
                        </b-list-group>
                      </b-card-body>
                    </b-card>
                  </b-col>

                  <b-col>
                    <b-card no-body id="ciclo" class="mb-1 block-resumo">
                      <b-card-header header-tag="header" class="p-1" role="tab">Período</b-card-header>
                      <b-card-body>
                        <b-list-group>
                          <b-list-group-item class="item-group-nav d-flex justify-content-between align-items-center">
                            <strong>Início</strong>
                            <b-badge variant="light" pill>{{ periodoInicio.toLocaleDateString('pt-BR', options)
                            }}</b-badge>
                          </b-list-group-item>
                          <b-list-group-item class="item-group-nav d-flex justify-content-between align-items-center">
                            <strong>Término</strong>
                            <b-badge variant="light" pill>{{ periodoFim.toLocaleDateString('pt-BR', options)
                            }}</b-badge>
                          </b-list-group-item>
                          <b-list-group-item class="item-group-nav d-flex justify-content-between align-items-center">
                            <strong>Ciclo</strong>
                            <b-badge variant="light" pill>{{ leadCycleType }}</b-badge>
                          </b-list-group-item>
                          <!-- <b-list-group-item class="item-group-nav d-flex justify-content-between align-items-center">
                            Número
                            <b-badge variant="info" pill>{{ leadCycleNumber }}</b-badge>
                          </b-list-group-item> -->
                        </b-list-group>

                        <!--<b-row>
                          <b-col>
                            <b-form-group
                              id="fieldset1"
                              style="width: 49%;"
                              description=""
                              label="Início"
                              label-for="leadCycleStart">
                              <b-form-input id="leadCycleStart" v-model="leadCycleStart" readonly></b-form-input>
                            </b-form-group>
                          </b-col>
                          <b-col>
                            <b-form-group
                              id="fieldset1"
                              style="width: 49%;"
                              description=""
                              label="Fim"
                              label-for="leadCycleEnd">
                              <b-form-input id="leadCycleEnd" v-model="leadCycleEnd" readonly></b-form-input>
                            </b-form-group>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col>
                            <b-form-group
                              id="fieldset1"
                              style="width: 50%;"
                              description=""
                              label="Tipo"
                              label-for="leadCycleType">
                              <b-form-input id="leadCycleType" v-model="leadCycleType" readonly></b-form-input>
                            </b-form-group>
                          </b-col>
                          <b-col>
                            <b-form-group
                              id="fieldset1"
                              style="width: 50%;"
                              description=""
                              label="Número"
                              label-for="leadCycleNumber">
                              <b-form-input id="leadCycleNumber" v-model="leadCycleNumber" readonly></b-form-input>
                            </b-form-group>
                          </b-col>
                        </b-row>-->
                      </b-card-body>
                    </b-card>
                  </b-col>

                  <b-col>
                    <b-card no-body id="indicators" class="mb-1 block-resumo">
                      <b-card-header header-tag="header" class="p-1" role="tab">Indicadores</b-card-header>
                      <b-card-body>
                        <b-list-group>

                          <!-- Separador -->


                          <!-- Item: Total da Cota -->
                          <b-list-group-item class="item-group-nav d-flex justify-content-between align-items-center">
                            <strong>Total da Cota</strong>
                            <b-badge variant="info" pill>{{ TotalCota.toLocaleString("PT-br") }}</b-badge>
                          </b-list-group-item>
                          <!-- Item: Saldo para Consumo -->
                          <b-list-group-item class="item-group-nav d-flex justify-content-between align-items-center">
                            <strong>Total Consumido:</strong>
                            <b-badge variant="info" pill>{{ saldoTotal.toLocaleString("PT-br") }}</b-badge>
                          </b-list-group-item>
                          <!-- Item: Saldo para Consumo -->
                          <b-list-group-item class="item-group-nav d-flex justify-content-between align-items-center">
                            <strong>Saldo Disponível:</strong>
                            <b-badge variant="info" pill>{{ (TotalCota - saldoTotal < 0 ? 0 : TotalCota - saldoTotal
                            ).toLocaleString("PT-br") }}</b-badge>

                          </b-list-group-item>

                          <hr
                            style="border-color: rgba(114, 108, 108, 0.3);background-color: rgba(0, 0, 0, 0) !important;padding: 0px 0px 0px 0px !important; margin:10px 0px 0px 0px !important;height: 10px;">

                          <!-- Item: Consumido sem cota -->
                          <b-list-group-item class="item-group-nav d-flex justify-content-between align-items-center">
                            <strong>Consumo Gratuito:</strong>
                            <b-badge variant="info" pill>{{ leadFree.toLocaleString("PT-br") }}</b-badge>
                          </b-list-group-item>

                        </b-list-group>

                        <!--<b-row>
                          <b-col>
                            <b-form-group
                              id="fieldset1"
                              style="width: 100%;"
                              description=""
                              label="Total Cota"
                              label-for="leadTotalQuota">
                              <b-form-input id="leadTotalQuota" v-model="leadLimit" readonly></b-form-input>
                            </b-form-group>
                          </b-col>
                          <b-col>
                            <b-form-group
                              id="fieldset1"
                              style="width: 100%;"
                              description=""
                              label="Total Excedentes"
                              label-for="leadCycleExceeded">
                              <b-form-input id="leadCycleExceeded" v-model="leadCycleExceeded" readonly></b-form-input>
                            </b-form-group>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col>
                            <b-form-group
                              id="fieldset1"
                              style="width: 50%;"
                              description=""
                              label="Compras Empresa"
                              label-for="leadQuotaValue">
                              <b-form-input id="leadCompanyAccumulated" v-model="leadCompanyAccumulated" readonly></b-form-input>
                            </b-form-group>
                          </b-col>
                          <b-col>
                            <b-form-group
                              id="fieldset1"
                              style="width: 50%;"
                              description=""
                              label="Minhas compras"
                              label-for="leadCycleNumber">
                              <b-form-input id="leadMyAccumulated" v-model="leadMyAccumulated" readonly></b-form-input>
                            </b-form-group>
                          </b-col>
                        </b-row>-->
                      </b-card-body>
                    </b-card>
                  </b-col>
                </b-row>
              </b-collapse>
            </div>
          </div>
        </div>
      </div>
    </header>

    <div class=" app-container" style="padding-top:50px;">
      <div class="text-lg-center" id="divNoPurchase" v-if="leadMyAccumulated === 0">
        <b-alert show variant="info">
          <h5 class="alert-heading">Você não realizou nenhuma compra</h5>
        </b-alert>
        <!-- <button type="button" class="btn-filter featured-btn" name="button" @click="goToPurchase()">
          <i class="icon-filter"><img src="../../assets/icons/shopping-cart.svg"></i>Comprar dados
        </button> -->
      </div>
      <div class="table-consumo" v-if="leadMyAccumulated > 0">
        <b-row>
          <b-col cols="12">

            <ejs-grid :allowFiltering='true' :allowGrouping="false" :filterSettings='filterOptions' :allowPaging="true"
              :pageSettings='pageSettings' :dataSource="data" :showColumnChooser="true" :allowResizing='true'
              :allowSorting='true' ref='grid'>
              <e-columns>
                <e-column field="cStatusDesc" headerText="" width=90 textAlign="Center"
                  :template="statusTemplate"></e-column>
                <!-- <e-column field="nCycleNumber" headerText="Ciclo" width=100 v-if="!isDashboardMode"></e-column> -->
                <e-column field="dtAddInFrmt" headerText="Solicitado em" width="140"></e-column>
                <!--
                <e-column field="dtConfirmFrmt" headerText="Resposta" width=127 type="datetime"></e-column>-->
                <!-- <e-column field="dtAddInFrmt" headerText="Solicitado" width=127 v-if="!isDashboardMode"></e-column>
                <e-column field="dtConfirmFrmt" headerText="Resposta" width=127 v-if="!isDashboardMode"></e-column> -->
                <!-- <e-column field="type" headerText="Tipo" width=90 allowResizing=true :visible=true textAlign="Left"
                  v-if="!isDashboardMode"></e-column> -->
                <e-column field="cAlias" headerText="Nome" textAlign="Left" width=250 allowResizing=true
                  allowTextWrap=true></e-column>
                <!-- <e-column field="cTag" headerText="Origem do Dado" width=197 allowResizing=true :visible=true
                  v-if="!isDashboardMode"></e-column> -->
                <e-column field="cTick" headerText="Chave" width=100 allowResizing=true textAlign="Left" :visible=true
                  v-if="!isDashboardMode"></e-column>

                <e-column field="nCountChunk" headerText="Total de Registros" width=180 allowResizing=true
                  :visible='true' v-show="!isDashboardMode" v-if="!isDashboardMode"></e-column>
                <e-column field="nNewOnes" headerText="Contabilizados" width=170 allowResizing=true :visible='true'
                  v-if="!isDashboardMode"></e-column>
                <!-- <e-column field="nLimit" headerText="Limite Aplicado" width=200 allowResizing=true :visible='true'
                  v-if="!isDashboardMode"></e-column> -->
                <!-- <e-column field="bOverflow" headerText="Extração Excedente" :visible='true'
                  v-if="!isDashboardMode"></e-column> -->
                <!-- <e-column field="nCountExist" headerText="Existente" width=190 :visible='true'
                  v-if="!isDashboardMode"></e-column> -->
                <!-- <e-column field="nCountCoexist" headerText="Registros Existente" width=180 :visible='true'
                  v-if="!isDashboardMode"></e-column> -->
                <!-- <e-column field="cUser" headerText="Usuário" width=357 allowResizing=true :visible='true'
                  v-if="!isDashboardMode"></e-column> -->
                <!-- <e-column field="gdIdEvent" headerText="Identificador" width=290 allowResizing=true :visible='true'
                  v-if="!isDashboardMode"></e-column>
                <e-column field="dtInitFrmt" headerText="Inicio (Ciclo)" width=127 :visible="false"
                  v-if="!isDashboardMode"></e-column>
                <e-column field="dtEndFrmt" headerText="Termino (Ciclo)" width=127 :visible="false"
                  v-if="!isDashboardMode" s></e-column> -->
              </e-columns>
            </ejs-grid>

          </b-col>
        </b-row>
        <b-row>
          <b-col cols="11">
            <b-row v-show="configFile" style="padding-top: 10px;">
              <b-col cols="3" style="padding-top: 5px;">
                <span style="font-size: 12px; color: #6c757d;">Delimitador de campos:</span>
              </b-col>
              <b-col cols="4">
                <b-form-select v-model="columnDelimiter" :options="columnDelimiters" text-field="text"
                  value-field="value" size="sm">
                </b-form-select>
              </b-col>
              <b-col cols="2" style="padding-top: 5px;">
                <span style="font-size: 12px; color: #6c757d;">Delimitador de texto:</span>
              </b-col>
              <b-col cols="3">
                <b-form-select v-model="textDelimiter" :options="textDelimiters" text-field="text" value-field="value"
                  size="sm">
                </b-form-select>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="1">
            <b-btn style="margin: 10px;" @click="showConfigFile" v-b-tooltip.hover title="Configurar" variant="link"><i
                class="fas fa-cog"></i></b-btn>
          </b-col>
        </b-row>


        <!-- <b-row style=" margin: 20px; border: #0a0b0d solid 1px; max-width: 50%; border-radius: 5px; padding:5px;"      v-if="configFile">
          <b-row>
            <b-col>
              <b-card no-body class="mb-1 block-resumo">
                <b-card-header header-tag="header" class="p-1" role="tab">Configurações do Arquivo</b-card-header>
                <b-card-body>
                  <b-list-group>
                    <b-list-group-item class="d-flex justify-content-between align-items-center">
                      <b-form-group id="input-group-2" label="Delimitador de campos:" label-for="input-2">
                        <b-form-select v-model="columnDelimiter" :options="columnDelimiters" text-field="text"
                          value-field="value" size="sm">
                        </b-form-select>
                      </b-form-group>
                    </b-list-group-item>
                    <b-list-group-item class="d-flex justify-content-between align-items-center">
                      <b-form-group id="input-group-2" label="Delimitador de texto:" label-for="input-2">
                        <b-form-select v-model="textDelimiter" :options="textDelimiters" text-field="text"
                          value-field="value" size="sm">
                        </b-form-select>
                      </b-form-group>
                    </b-list-group-item>
                  </b-list-group>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
          <!--<b-row>
              <b-col>
                <p>Delimitador de campos: </p>
              </b-col>
              <b-col cols="4">
                &lt;!&ndash;<b-form-input v-model="charSeparator" class="text-right"></b-form-input>&ndash;&gt;
                <b-form-select v-model="columnDelimiter"
                               :options="columnDelimiters"
                               text-field="text" value-field="value">
                </b-form-select>
              </b-col>
            </b-row>
          <b-row>
            <b-col>
              <p>Delimitador de texto: </p>
            </b-col>
            <b-col cols="2">
              <b-form-select v-model="rowDelimiter"
                             :options="textDelimiters"
                             text-field="text" value-field="value">
              </b-form-select>
            </b-col>
          </b-row>-->
        <!-- </b-row> -->
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { DatePickerPlugin } from "@syncfusion/ej2-vue-calendars";
import { ColumnChooser, Toolbar, Page, Resize, Filter, GridPlugin, Sort, Group, CommandColumn } from "@syncfusion/ej2-vue-grids";
import { L10n, setCulture } from '@syncfusion/ej2-base'
import services from '../http/request'
import common from './datalead-common'
import { DataLeadBusiness } from './datalead-business'
import localization from '../localization/ejGrid'
import messenger from '../messenger/messenger'
import { Billing } from '../../service/Billing'

Vue.use(DatePickerPlugin);
Vue.use(GridPlugin);
export default Vue.extend({
  name: "LeadManager",
  components: {},
  metaInfo: {
    title: "Administração de Consumo e Exportação de Dados"
  },
  provide: { grid: [ColumnChooser, Toolbar, Resize, Page, Filter, Sort, Group, CommandColumn] },
  data: function () {
    return {
      isLoading: true,
      vGrid: true,
      billingService: Billing.build({}),
      dataDetails: null,
      data: [],
      filterOptions: { type: 'Excel' },
      pageSettings: { pageSize: 7 },
      toolbarOptions: ['ColumnChooser'],
      saldoTotal: 0,
      TotalCota: 0,
      periodoInicio: null,
      periodoFim: null,
      leadAccount: "",
      leadClient: "",
      leadCycleStart: "",
      leadCycleEnd: "",
      leadCycleNumber: "",
      leadCycleType: "",
      leadCycleAccumulated: 0,
      leadCycleExceeded: 0,
      leadMyAccumulated: 0,
      leadCompanyAccumulated: 0,
      leadMyExceeded: "",
      leadDataHeader: null,
      leadLimit: 0,
      leadFree: 0,
      showGrid: true,
      configFile: false,
      columnDelimiter: ";",
      textDelimiter: "",
      downloadIndex: -1,
      columnDelimiters: [
        /*{value: '\t', text: 'Tabulação: TAB'},*/
        { value: ';', text: 'Ponto e vírgula: ;' },
        { value: ',', text: 'Vírgula: ,' },
        /*{value: ' ', text: 'Espaço em branco'},*/
        { value: '|', text: 'Pipe: |' }
      ],
      textDelimiters: [
        { value: '', text: 'Nenhum' },
        { value: '\"', text: 'Aspas duplas: "' },
        { value: '\'', text: 'Aspas simples: \'' }
      ]
    }
  },
  computed: {},
  methods: {

    test() {
      console.log('test')
      console.log(this.data)
      this.vGrid = !this.vGrid

    },
    goToPurchase() {
      this.$router.push("/flow-sources")
    },
    showConfigFile() {
      this.configFile = !this.configFile
    },
    downloadFile(gdIdEvent) {
      //let request = new services({environment: 'local', tag: 'billing'});
      let request = new services({ tag: 'billing' });
      let endPoint = `/api/0.1-a/summarize/download/${gdIdEvent}/${this.columnDelimiter}/${this.textDelimiter}`;
      let config = {
        headers: {
          'Content-Type': 'application/json',
        },
        responseType: 'blob'
      };

      request.get(endPoint, config, (response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', response.headers['filename'] || 'file.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }, (error) => {
        console.log(error);
        messenger.error({ position: 'top-end', title: 'Erro no download' });
      });
    },
    loadUserCulture: function () {
      let userLang = navigator.language;
      if (userLang === 'pt-BR')
        L10n.load(localization['pt-BR']);
      setCulture(userLang);
      console.log(`browser language: ${userLang}`)
    },
    async getDetails() {
      console.log('getDetails-start')


      try {
        this.isLoading = true




        let self = this
        let environment = Vue.prototype.$foundation.getEnvironmentId()
        let cClientTag = Vue.prototype.$foundation.getEnvironmentName()

        await self.billingService.getDetails(environment, cClientTag).then((response) => {
          let data = response.data
          if (data["data_header"][0].length === 0) return
          let header = data["data_header"][0]
          let dataset = data["data_set"]

          self.leadFree = header["sumCountFreeChunk"]
          self.saldoTotal = header["sumCountChunk"]
          self.TotalCota = header["quoteLimit"]
          self.periodoInicio = new Date(header["dtStartIn"]);
          self.periodoFim = new Date(header["dtFinishIn"]);
          self.dataDetails = data
          //loadDataV2
          const environment = Vue.prototype.$foundation.getEnvironmentName();
          const userId = Vue.prototype.$foundation.getCurrentUser();
          const leadBusiness = new DataLeadBusiness(environment, userId);
          this.leadDataHeader = header;
          leadBusiness.loadDataV2(header, dataset).then((res) => {
            console.log('loadDataV2 - res')
            console.log(res)
            this.data = res.UserData;
            this.leadAccount = res.UserAccount;
            this.leadClient = res.UserCompany;
            this.leadCycleStart = res.CycleIni;
            this.leadCycleEnd = res.CycleEnd;
            this.leadCycleNumber = res.CycleNumber;
            this.leadCycleType = res.CycleType;
            this.leadCycleAccumulated = res.LeadTotalBayed;
            this.leadCycleExceeded = res.TotalLeadApprovedOverflow;
            this.leadLimit = res.QuoteLimit;
            this.leadMyAccumulated = res.LeadMyBayed;
            this.leadMyExceeded = res.MyLeadApprovedOverflow;
            this.leadCompanyAccumulated = res.leadCompanyAccumulated;
          })
            .catch((error) => {
              console.log(error);
              messenger.show({ text: error.message || "Ops...algo deu errado!", type: error.type || "error" });
            })

          console.log(data)
        }).catch((error) => {
          console.log(error)
        })
      }
      catch (e) {
        console.log(e)
      }
      finally {
        this.isLoading = false
      }
    },


    loadLead: function () {
      const environment = Vue.prototype.$foundation.getEnvironmentName();
      const userId = Vue.prototype.$foundation.getCurrentUser();






      const leadBusiness = new DataLeadBusiness(environment, userId);
      leadBusiness.loadLead()
        .then((res) => {
          this.leadDataHeader = res.data;
          leadBusiness.loadData(res.data)
            .then((res) => {
              this.data = res.UserData;
              this.leadAccount = res.UserAccount;
              this.leadClient = res.UserCompany;
              this.leadCycleStart = res.CycleIni;
              this.leadCycleEnd = res.CycleEnd;
              this.leadCycleNumber = res.CycleNumber;
              this.leadCycleType = res.CycleType;
              this.leadCycleAccumulated = res.LeadTotalBayed;
              this.leadCycleExceeded = res.TotalLeadApprovedOverflow;
              this.leadLimit = res.QuoteLimit;
              this.leadMyAccumulated = res.LeadMyBayed;
              this.leadMyExceeded = res.MyLeadApprovedOverflow;
              this.leadCompanyAccumulated = res.leadCompanyAccumulated;
            })
            .catch((error) => {
              console.log(error);
              messenger.show({ text: error.message || "Ops...algo deu errado!", type: error.type || "error" });
            })
        })
        .catch((error) => {
          console.log(error);
          messenger.show({ text: error.message || "Ops...algo deu errado!", type: error.type || "error" });
        })
    },
    onDownloadClicked: function (args) {
      if (args.data.index === this.downloadIndex) return;
      this.downloadIndex = args.data.index;
      console.log(args.data.cTag)
      switch (args.data.cStatus) {
        case "Done":
          this.downloadFile(args.data.gdIdEvent);
          break;
        case "Unapproved":
          common.processPurchase(args.data);
          break;
        case "NotAccounted":
          return false;
        case "Waiting":
          return false;
          break;
      }
    },
    statusTemplate: function () {
      return {
        template: Vue.component('statusTemplate', {
          //template: '<ejs-button :cssClass="getButtonClass" :content="getButtonText" style="width:120px;"></ejs-button>',
          //template: '<b-button :id="buttonId" :disabled="buttonState" size="sm" :variant="customClass"><i class="fas fa-download"></i></b-button>',
          template: '<button :id="buttonId" :class="customClass" :disabled="buttonState" @click="onClick" type="button" style="width:20px;height: 30px;">{{buttonText}}' +
            '<i :class="buttonIcon"></i></button>',
          data() {
            return {
              data: {}
            }
          },
          props: {
            customClass: {
              type: String,
              default: "btn btn-primary"
            },
            buttonId: {
              type: String,
              default: ""
            },
            buttonIcon: {
              type: String,
              default: "fas fa-download"
            },
            buttonState: {
              type: Boolean,
              default: true
            },
            buttonText: {
              type: String,
              default: ""
            },
            buttonTooltip: {
              type: String,
              default: ""
            },
            actionTemlate: {
              type: String,
              default: ""
            }
            /*onClick: {
              type: Function,
              required: true
            }*/
          },
          computed: {},
          methods: {
            getButtonClass: function () {
              let status = this.data['cStatus'];
              let buttonClass = "primary";

              switch (status) {
                case "Done":
                  buttonClass = "primary";
                  break;
                case "Unapproved":
                  buttonClass = "danger";
                  break;
                case "Waiting":
                  buttonClass = "warning";
                  break;
                default:
                  buttonClass = "primary";
                  break;
              }
              return `${buttonClass}`;
            },
            getButtonClass2: function () {
              let status = this.data['cStatus'];
              let buttonClass = "btn-success";

              switch (status) {
                case "Done":
                  buttonClass = "btn-success";
                  break;
                case "Unapproved":
                  buttonClass = "btn-danger";
                  break;
                case "Waiting":
                  buttonClass = "btn-warning";
                  break;
                case "NotAccounted":
                  buttonClass = '';
                  break
                default:
                  buttonClass = "btn-primary";
                  break;
              }
              return `btn ${buttonClass}`;
            },
            getButtonIcon: function () {
              let status = this.data['cStatus'];

              switch (status) {
                case "Done":
                  return 'fas fa-download';
                case "Unapproved":
                  return "far fa-thumbs-down";
                case "Waiting":
                  return "fa fa-cog fa-spin";
                case "NotAccounted":
                  return '';
                default:
                  return 'fas fa-download';
              }
            },
            getButtonState: function () {
              let status = this.data['cStatus'];
              let buttonState = false;

              switch (status) {
                case "Waiting":
                  buttonState = true;
                  break;
                case "NotAccounted":
                  buttonState = true;
                  break;
                default:
                  buttonState = false;
                  break;
              }
              return buttonState;
            },
            getButtonText: function () {
              let progress = this.data['nProgress'];
              let status = this.data['cStatus'];

              switch (status) {
                case "Done":
                  return '         ';
                case "NotAccounted":
                  return '';
                default:
                  return `${progress}%   `;
              }
            },
            getButtonTooltip: function () {
              let progress = this.data['nProgress'];
              let statusDesc = this.data['cStatusDesc'];
              return `${statusDesc} ${progress}%`;
            },
            getTemplate: function () {
              let status = this.data['cStatus'];
              let template = "<div></div>";

              switch (status) {
                case "Done":
                  template = '<button :class="customClass" :disabled="buttonState" @click="onClick" type="button">{{this.buttonText}}' +
                    '<i class="fas fa-download"></i></button>';
                  break;
                default:
                  template = "<div></div>";
                  break;
              }
              return template;
            },
            onClick: function (e) {
              if (e)
                e.preventDefault();
              console.log("onClick")
              let args = {
                event: e,
                data: this.data
              };
              this.$bus.$emit('downloadClick', args)
            }
          },
          mounted() {
            this.customClass = this.getButtonClass2();
            this.buttonIcon = this.getButtonIcon();
            this.buttonId = this.data['gdIdEvent'];
            this.buttonState = this.getButtonState();
            this.buttonText = this.getButtonText();
            this.buttonTooltip = this.getButtonTooltip();
          }
        })
      }
    }
  },
  created() {
    this.loadUserCulture();
    this.$bus.$on('downloadClick', (args) => {
      this.onDownloadClicked(args);
    });
  },
  beforeDestroy() {
    this.$bus.$off('downloadClick');
  },
  mounted() {

    let self = this
    if (!this.$session.exists())
      this.$router.push('/');
    else
      self.getDetails()
    //this.loadLead()
  },
  props: {
    isDashboardMode: Boolean,
  }
})
</script>

<style>
@import "../../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";
/*@import "../../../node_modules/@syncfusion/ej2-vue-grids/styles/bootstrap.css";*/
/*@import "../../../node_modules/@syncfusion/ej2-vue-grids/styles/fabric.css";*/
@import '../../../node_modules/sweetalert2/dist/sweetalert2.min.css';
@import '../../../node_modules/axios-progress-bar/dist/nprogress.css';

#nprogress .bar {
  background: red !important;
}

#nprogress .peg {

  box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
}

#nprogress .spinner-icon {
  border-top-color: red !important;
  border-left-color: red !important;
}

/* Ajuste a altura das linhas */
.e-grid .e-row {
  height: 30px;
  /* Altere para o valor desejado */
}

/* Ajuste o padding interno das células */
.e-grid .e-rowcell {
  padding: 2px;
  /* Reduza o padding para encurtar a altura visual */
}

.item-group-nav {

  padding: 2px;


  box-sizing: border-box;
  border-radius: 5px;

  i {
    margin-right: 10px;
  }
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loading-spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin-bottom: 10px;
}
</style>
